export type UseCaseSlug = 'for-novelists' | 'for-journalists' | 'for-screenwriters';

export interface UseCasePageDefinition {
  slug: UseCaseSlug;
  path: `/${UseCaseSlug}`;
  keyPrefix: 'use_case_novelists' | 'use_case_journalists' | 'use_case_screenwriters';
  benefitCount: 4;
}

export const USE_CASE_PAGES: UseCasePageDefinition[] = [
  {
    slug: 'for-novelists',
    path: '/for-novelists',
    keyPrefix: 'use_case_novelists',
    benefitCount: 4,
  },
  {
    slug: 'for-journalists',
    path: '/for-journalists',
    keyPrefix: 'use_case_journalists',
    benefitCount: 4,
  },
  {
    slug: 'for-screenwriters',
    path: '/for-screenwriters',
    keyPrefix: 'use_case_screenwriters',
    benefitCount: 4,
  },
];

export function isUseCasePath(pathname: string): boolean {
  return USE_CASE_PAGES.some((page) => page.path === pathname);
}

export function findUseCasePage(pathname: string): UseCasePageDefinition | undefined {
  return USE_CASE_PAGES.find((page) => page.path === pathname);
}
